import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';

export default function delayreasonsList(component){
  const Authorization='bearer '+localStorage.getItem('token');
  component.setState({ loading: true });
  fetch(`${API_URL}rest/V1/picker/getReasons`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({
        user_type:"rider",
        reason_type:"delay"
        })
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
            component.setState({ loading: false });
            console.log("delayReasonAction",data);
            component.props.delayReasonAction(data);
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/getdelayReasons.js